<!--
    班级管理
    功能：列表数据展示、查看学生信息、添加学生、二维码添加学生
-->
<template>
  <div class="class_manage school-center-padding">
    <AppList
      ref="list"
      :list.sync="list"
      :create-label="$permissions('school_classes_list_add') ? '创建班级' : ''"
      title=""
      api="/api/classes"
      api-type="/api/classes?is_show_student_list=1"
      @create="toCreate">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            v-if="$permissions('school_classes_list_status')"
            label="班级状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.teaching_status === 1">上课中</span>
              <span v-else>已结束</span>
              <el-switch
                :value="scope.row.teaching_status === 1"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                @change="switchStatus(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <template v-if="$store.state.from === 'schoolCenter'">
                <el-link
                  v-if="$permissions('school_classes_list_detail')"
                  @click="ClassDetail(scope.row)"
                >查看</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  v-if="$permissions('school_classes_list_edit')"
                  @click="edit(scope.row)"
                >编辑</el-link>
                <i class="icon-splite">|</i>
                <el-link
                  @click="handlerClassCode(scope.row)"
                >班级二维码</el-link>
              </template>
              <template v-else>
                <el-button
                  v-if="$permissions('school_classes_list_detail')"
                  size="small"
                  @click="ClassDetail(scope.row)"
                >查看</el-button>
                <el-button
                  v-if="$permissions('school_classes_list_edit')"
                  size="small"
                  @click="edit(scope.row)"
                >编辑</el-button>
                <i class="icon-splite">|</i>
                <el-button
                  @click="handlerClassCode(scope.row)"
                >班级二维码</el-button>
                <!--              <el-button-->
                <!--                size="small"-->
                <!--                type="danger"-->
                <!--                plain-->
                <!--                @click="del(scope.row.id)"-->
                <!--              >删除</el-button>-->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      :title="dialogTitle === 'add' ? '创建班级': '修改班级'"
      :visible.sync="formDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeClass"
      width="1000px">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="125px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="班级名称："
              prop="name">
              <el-input
                v-model="formData.name"
                :maxlength="20"
                placeholder="请输入班级名称"/>
            </el-form-item>
            <el-form-item
              label="负责老师："
              prop="teacher_id">
              {{ formData.teacher_name }}
              <el-button
                type="primary"
                size="small"
                @click="choiceTeacher">选择老师</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级标签：">
              <el-input
                v-model="formData.tag_remark"
                :maxlength="20"
                placeholder="请输入班级标签"/>
            </el-form-item>
            <el-form-item label="班级学生：">
              <div
                v-if="studentListName.length"
                class="studentsName">
                <div
                  v-for="(item, index) in studentListName"
                  :key="index"
                  class="el-tag el-tag--light"
                  style="margin:0 10px 10px 0;"
                >{{ item.name || item.student_name }}</div>
              </div>
              <el-button
                type="primary"
                size="small"
                @click="choiceStudent">选择学生</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="closeClass">取 消</el-button>
        <el-button
          type="primary"
          @click="submitClass">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="importTeacher"
      title="选择老师"
      width="1000px"
    >
      <TeacherSelect
        @teacherSelected="getTeacher"
      />
      <!--      <div-->
      <!--        slot="footer"-->
      <!--        class="dialog-footer">-->
      <!--        <el-button @click="importTeacher = false">取 消</el-button>-->
      <!--        <el-button-->
      <!--          type="primary"-->
      <!--          @click="submitImportTeacher">提 交</el-button>-->
      <!--      </div>-->
    </el-dialog>
    <el-dialog
      :visible.sync="importStudents"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="批量导学生"
      width="1000px"
    >
      <div class="downloads">
        <el-button
          type="primary"
          size="small"
          class="btn"
          icon="el-icon-plus"
          @click="editStudent">手动添加</el-button>
        <el-upload
          ref="upload"
          :auto-upload="false"
          :multiple="false"
          :show-file-list="false"
          :on-change="handleFileChange"
          action=""
          accept=".xlsx,.xls"
        >
          <el-button
            :loading="updataLoading"
            size="small"
            class="btn"
            icon="el-icon-upload2"
            type="primary">导入Excel</el-button>
        </el-upload>
        <el-button
          size="small"
          class="btn"
          plain
          icon="el-icon-download"
          @click="downloadTemplate">下载Excel模板</el-button>
      </div>
      <StudentSelect
        ref="studentListDom"
        :student-selected="currStudentList"
        :reload-student="reloadStudent"
        :import-students="importStudents"
        @studentList="getStudentList"
      />
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="importStudents = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitImportStudents">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addStudentDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="添加学生"
      width="800px">
      <el-form
        ref="studentForm"
        :model="studentForm"
        label-width="50px"
        class="studentForm">
        <el-form-item
          v-for="(item, index) in studentForm.studentList"
          :label="index + 1"
          :key="index"
          :prop="'studentList.' + index + '.name'"
          :rules="{ required: true, validator: validatePass, trigger: 'blur' }">
          <el-input
            v-model="item.name"
            class="student_input"
            placeholder="请输入学生姓名"/>
          <el-input
            v-model="item.mobile"
            :ref="`studentList.${index}.name`"
            class="student_input"
            placeholder="请输入手机号"/>
          <el-select
            v-model="item.gender"
            placeholder="请选择性别">
            <el-option
              :value="1"
              label="男"/>
            <el-option
              :value="2"
              label="女"/>
          </el-select>
          <el-select
            v-if="grade"
            v-model="item.grade"
            placeholder="请选择年级">
            <el-option
              v-for="item in grade"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <el-button @click.prevent="removeStudentForm(item)">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitStudentForm()">提交</el-button>
          <el-button @click="addStudentDialog = false">取 消</el-button>
          <el-button @click="addStudentForm">新增学生</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 班级二维码弹窗 -->
    <class-code-dialog
      v-if="showClassCode"
      :class-info="curData"
      :visible.sync="showClassCode"
      @close-dialog="showClassCode = false"/>
    <!-- 导入excel结果 -->
    <file-result-dialog
      v-if="showExcelResult"
      :result-info="resultInfo"
      :visible.sync="showExcelResult"
      @close-dialog="showExcelResult = false"/>
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import list from '@/mixins/list';
import TeacherSelect from './TeacherSelect';
import StudentSelect from './StudentSelect';
import ClassCodeDialog from './components/ClassCodeDialog';
import FileResultDialog from './components/FileResultDialog';

export default {
  name: 'ClassManage',
  inject: ['reload'],
  components: {
    StudentSelect,
    TeacherSelect,
    ClassCodeDialog,
    FileResultDialog,
  },
  mixins: [list],
  data() {
    return {
      list: {},
      showClassCode: false,
      updataLoading: false,
      formDialogVisible: false,
      importTeacher: false,
      importStudents: false,
      importStudentList: [],
      currStudentList: [],
      reloadStudent: false,
      getStudentVal: [],
      studentListName: [],
      addStudentDialog: false,
      curData: {},
      resultInfo: {
        inSchool: null,
        inClasses: null,
        isSuccess: null,
        notComplete: null,
      }, // 导入结果
      showExcelResult: false,
      form: {
        name: '', // 班级名称
        teacher_id: '', // 老师id
        tag_remark: '', // 班级标签
        student_ids: [], // 班级学生
      },
      formData: {},
      rules: {
        name: [
          { required: true, message: '请输入班级名称', trigger: 'blur' },
        ],
        teacher_id: [
          { required: true, message: '请选择老师' },
        ],
      },
      dialogTitle: '',
      studentForm: {
        studentList: [{
          name: '',
          mobile: '',
          gender: 1,
          grade: 1,
        }],
      },
      isCreated: true,
    };
  },
  computed: {
    columns() {
      return [
        { prop: 'name', label: '班级名称' },
        { prop: 'number', label: '班级码' },
        { prop: 'student_count', label: '学生人数' },
        { prop: 'teacher.name', label: '负责老师' },
        { prop: 'created_at', label: '创建时间', width: '160px' },
      ];
    },
    searchArr() {
      const column = [
        { prop: 'name', label: '班级名称' },
        { prop: 'teacher_name', label: '负责老师' },
        { prop: 'number', label: '班级码' },
      ];
      return [
        {
          selectValue: [
            { value: 1, name: '上课中' },
            { value: 2, name: '已结束' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'teaching_status',
          placeholder: '请选择上课状态',
        },
        { componentType: 'AppSearchColumn', searchType: column },
      ];
    },
    grade() {
      return this.$store.state.grade;
    },
  },
  created() {
    this.formData = this.form;
    // console.log('studentListName', this.studentListName);
  },
  methods: {
    // 上课统计入口
    Statistics(id) {
      this.$router.push(`/student/statistics/${id}`);
    },
    // 我的班级入口
    StudentClass(id) {
      this.$router.push(`/student/class/${id}`);
    },
    // 班级详情入口
    ClassDetail(row) {
      this.$router.push(`/classmanage/detail/${row.id}`);
    },
    // 创建班级按钮
    toCreate() {
      this.formDialogVisible = true;
      this.dialogTitle = 'add';
      this.formData = this.form;
      this.studentListName = [];
      this.currStudentList = [];
      this.getStudentVal = [];
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 选择老师
    choiceTeacher() {
      this.importTeacher = true;
    },
    getTeacher(val) {
      this.importTeacher = false;
      this.formData.teacher_id = val.id;
      this.formData.teacher_name = val.name;
      this.$nextTick(() => {
        this.$refs.form.clearValidate('teacher_id');
      });
    },
    // 选择学生
    choiceStudent() {
      this.currStudentList = this.studentListName;
      this.importStudents = true;
      this.$nextTick(() => {
        this.$refs.studentListDom.getStudentList(1);
      });
    },
    // 手动添加学生
    editStudent() {
      this.studentForm = {
        studentList: [{
          name: '',
          mobile: '',
          gender: 1,
          grade: 1,
        }],
      };
      this.addStudentDialog = true;
    },
    getStudentList(val) {
      this.getStudentVal = val;
    },
    submitImportStudents() {
      this.studentListName = [];
      this.formData.student_ids = [];
      this.importStudentList = [];
      this.getStudentVal.forEach((item, index) => {
        this.importStudentList.push(item.id);
      });
      this.getStudentVal.forEach((item, index) => {
        this.studentListName.push({
          id: item.id,
          name: item.name,
          uuid: item.uuid,
          school_id: item.school_id,
        });
      });
      // this.formData.student_ids = this.importStudentList;
      this.importStudents = false;
    },
    validatePass(rule, value, callback) {
      const index = rule.field;
      const mobile = this.$refs[index][0].value;
      if (value === '' || mobile === '') {
        callback(new Error('姓名和手机号不能为空'));
      } else if (!(/^1\d{10}$/.test(mobile))) {
        callback(new Error('请填写正确的手机号'));
      } else {
        callback();
      }
    },
    submitStudentForm() {
      this.$refs.studentForm.validate((valid) => {
        if (valid) {
          // 批量新增学生
          if (this.isCreated) {
            this.isCreated = false;
            this.$http.post('/api/student/batch-store', { student_list: this.studentForm.studentList })
              .then(() => {
                this.isCreated = true;
                this.$message.success('批量新增学生成功！');
                this.addStudentDialog = false;
                this.importStudents = false;
                this.$nextTick(() => {
                  this.importStudents = true;
                });
              })
              .catch((err) => {
                this.isCreated = true;
                this.$message.error(err.message);
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeStudentForm(item) {
      const index = this.studentForm.studentList.indexOf(item);
      if (index !== -1) {
        this.studentForm.studentList.splice(index, 1);
      }
    },
    addStudentForm() {
      this.studentForm.studentList.push({
        name: '',
        mobile: '',
        gender: 1,
        grade: 1,
      });
    },
    // 编辑班级按钮
    edit(row) {
      this.formDialogVisible = true;
      this.formData = { ...row };
      // this.formData.teacher_name = row.teacher.name;
      row.teacher ? this.formData.teacher_name = row.teacher.name : null;
      this.dialogTitle = 'edit';
      if (row.student && row.student.length) {
        this.studentListName = [];
        const student_ids = [];
        row.student.forEach((item, index) => {
          student_ids.push(item.student_id);
        });
        row.student.forEach((item) => {
          this.studentListName.push({
            id: item.student_id,
            name: item.student_name,
            uuid: item.uuid,
            school_id: item.school_id,
          });
        });
      } else {
        this.studentListName = [];
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 删除班级按钮
    del(id) {
      this.$confirm('是否删除班级?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.delete(`/api/classes/${id}`)
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.reload();
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      });
    },
    // 班级二维码按钮
    handlerClassCode(row) {
      // console.log(row);
      const data = Object.assign({}, row);
      this.curData = {
        class_name: data.name,
        class_teacher: data.teacher ? data.teacher.name : '',
        class_num: data.number,
        classes_code: data.classes_code,

      };
      this.showClassCode = true;
    },
    // 导入excel
    handleFileChange(file, fileList) {
      this.resultInfo = {
        inSchool: null,
        inClasses: null,
        isSuccess: null,
        notComplete: null,
      };
      this.updataLoading = true;
      const formData = new FormData();
      formData.append('excel', file.raw);
      this.formData.id && formData.append('classes_id', this.formData.id);
      this.$http
        .post('/api/classes/student/import-excel', formData)
        .then(async (res) => {
          this.updataLoading = false;
          if (res.status_code === 200) {
            if (res.data.in_shool.length) { // 已存在学校
              const schoolStudent = [];
              res.data.in_shool.forEach((item) => {
                schoolStudent.push(item.name);
              });
              this.resultInfo.inSchool = {
                count: schoolStudent.length,
                names: schoolStudent.join(),
              };
            }
            if (res.data.in_classes.length) { // 已存在班级
              const classStudent = [];
              res.data.in_classes.forEach((item) => {
                classStudent.push(item.name);
              });
              this.resultInfo.inClasses = {
                count: classStudent.length,
                names: classStudent.join(),
              };
            }
            if (res.data.not_complete.length) { // 缺少必填项
              const noData = [];
              res.data.not_complete.forEach((item) => {
                if (!item.name && item.mobile) noData.push(item.mobile);
                if (item.name && !item.mobile) noData.push(item.name);
                if (item.name && item.mobile) noData.push(item.name);
              });
              const obj = {
                noData,
              };
              this.resultInfo.notComplete = obj;
            }
            if (res.data.success.length) { // 导入成功
              // this.$message.success(`${res.data.success.length}条记录导入成功！`);
              this.resultInfo.isSuccess = res.data.success.length;
            }
            console.log('导入结果', this.resultInfo)
            this.showExcelResult = true;
            await this.$refs.list.getList();
            const upLaodArr = [];
            res.data.success.forEach((item) => {
              upLaodArr.push({
                id: item.student_id,
                name: item.name,
                uuid: item.users_id,
                school_id: item.school_id,
              });
            });
            this.$refs.studentListDom.addStudent(upLaodArr);
            this.$refs.studentListDom.getStudentList();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 下载模板
    downloadTemplate() {
      FileSaver.saveAs('/excel/学生导入模板.xlsx', '学生导入模板.xlsx');
    },
    // 修改班级状态
    switchStatus(row) {
      const teaching_status = {
        teaching_status: row.teaching_status === 1 ? 2 : 1,
      };
      this.$confirm('确定修改状态吗', '确认', {
        showCancelButton: true,
        type: 'success',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--success',
      })
        .then(() => {
          this.$http
            .patch(`/api/classes/${row.id}/teaching_status`, teaching_status)
            .then((res) => {
              this.$message.success('状态修改成功');
              this.reload();
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 关闭创建班级
    closeClass() {
      this.formDialogVisible = false;
    },
    // 提交创建班级
    submitClass() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isCreated) {
            if (this.dialogTitle === 'add') {
              // 创建班级
              this.isCreated = false;
              this.$http.post('/api/classes', this.formData)
                .then((res) => {
                  if (this.studentListName.length > 0) {
                    this.$message.success('创建班级成功，正在加入学生...');
                    // 学生进班
                    const data = {
                      classes_id: res.data.id,
                      student_list: this.studentListName.map(item => ({
                        uuid: item.uuid,
                        student_id: item.id,
                        school_id: item.school_id,
                      })),
                    };
                    this.$http.post('/api/student/join-classes', data)
                      .then(() => {
                        this.isCreated = true;
                        this.$message.success('加入学生成功！');
                        this.formDialogVisible = false;
                        this.reload();
                      })
                      .catch((err) => {
                        this.isCreated = true;
                        this.$message.error(err.message);
                      });
                  } else {
                    this.isCreated = true;
                    this.$message.success('创建班级成功！');
                    this.formDialogVisible = false;
                    this.reload();
                  }
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            } else {
              console.log('this.formData', this.formData);
              if (!this.formData.teacher_name) {
                this.$message.warning('请选择负责老师！');
                return;
              }
              const list = this.studentListName.map(item => ({
                uuid: item.uuid,
                student_id: item.id,
                school_id: item.school_id,
              }));
              const data = {
                name: this.formData.name,
                teacher_id: this.formData.teacher_id,
                tag_remark: this.formData.tag_remark,
                is_update_student: 1,
                student_list: list,
              };
              // 修改
              this.isCreated = false;
              this.$http.put(`/api/classes/${this.formData.id}`, data)
                .then(() => {
                  this.isCreated = true;
                  this.$message.success('保存成功');
                  this.formDialogVisible = false;
                  this.reload();
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message.error(err.message);
                });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .class_manage {
    .form_img {
      width: 100px;
      height: 100px;
    }
    .logo {
      margin-bottom: 9px;
    }
    .el-radio {
      margin-right: 5px;
    }
    .el-icon-question {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      font-size: 18px;
      color: var(--color-primary);
    }
    .el-select {
      width: 100%;
    }
    .studentForm {
      .student_input {
        display: inline-block;
        width: 180px;
      }
      .el-select {
        width: 120px;
      }
    }
  }
  .downloads{
    display: flex;
    .btn{
      margin-left: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/ClassManage/index.vue